<template>
    <div class="c-client-form">
        <div class="component">
            <h3 class="text--upper">Dane kontaktowe</h3>
            <div class="pt--4 mb--4 c-client-form__container">
                <div class="flex-row">
                    <div class="flex-col pt--1">
                        <label>
                            <span class="input-placeholder" :class="{ 'compleeted': lead.email }">E-mail *</span>
                            <input type="text" name="email" v-model="lead.email">
                            <small class="text-error" v-if="!lead.email">To pole jest wymagane</small>
                        </label>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col c-client-form__border--right pt--2">
                        <label>
                            <span class="input-placeholder" :class="{ 'compleeted': lead.first_name }">Imię *</span>
                            <input type="text" name="name" v-model="lead.first_name">
                            <small class="text-error" v-if="!lead.first_name">To pole jest wymagane</small>
                        </label>
                    </div>
                    <div class="flex-col c-client-form__border--left pt--2">
                        <label>
                            <span class="input-placeholder" :class="{ 'compleeted': lead.last_name }">Nazwisko *</span>
                            <input type="text" name="surname" v-model="lead.last_name">
                            <small class="text-error" v-if="!lead.last_name">To pole jest wymagane</small>
                        </label>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col pt--2">
                        <label>
                            <span class="input-placeholder" :class="{ 'compleeted': lead.postcode_val }">Kod pocztowy</span>
                            <input type="text" name="postcode" v-model="lead.postcode_val">
                        </label>
                    </div>
                    <div class="flex-col c-client-form__border">
                        <label>
                            <span class="input-placeholder" :class="{ 'compleeted': lead.city_val }">Miejscowość</span>
                            <input type="text" name="city" v-model="lead.city_val">
                        </label>
                    </div>
                    <div class="flex-col c-client-form__border c-client-form__border--noborder">
                        <label>
                            <span class="input-placeholder" :class="{ 'compleeted': lead.address_val }">Adres</span>
                            <input type="text" name="address" v-model="lead.address_val">
                        </label>
                    </div>
                    <div class="flex-col c-client-form__border--last pt--2">
                        <label>
                            <span class="input-placeholder" :class="{ 'compleeted': lead.country_val }">Kraj</span>
                            <input type="text" name="country" v-model="lead.country_val">
                        </label>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col pt--2">
                        <label>
                            <span class="input-placeholder" :class="{ 'compleeted': lead.phone_number }">Numer komórkowy
                                *</span>
                            <input type="text" name="phone" v-model="lead.phone_number">
                            <small class="text-error" v-if="!lead.phone_number">To pole jest wymagane</small>
                            <small class="text-error" v-else-if="!isPhoneValid">Numer musi składać się z min. 9 cyfr</small>
                        </label>
                    </div>
                    <div class="flex-col c-client-form__border--left pt--2">
                        <label>
                            <span class="input-placeholder"
                                :class="{ 'compleeted': lead.phone_number_additional_val }">Numer
                                telefonu</span>
                            <input type="text" name="phone2" v-model="lead.phone_number_additional_val">
                        </label>
                    </div>
                </div>
                <label>
                    <div class="mt--4">
                        <small class="text-error" v-if="lead.accept1_val != 1">To pole jest wymagane</small>
                        <div class="flex-row">
                            <div class="mr--1">
                                <input type="checkbox" true-value="1" false-value="0" v-model="lead.accept1_val">
                            </div>
                            <div class="flex-col flex-col-9">
                                Zgadzam się, aby podane tu przeze mnie dane zostały przetwarzane w celu umówienia wizyty
                                online.
                                Mam świadomość, że tę zgodę mogę w każdym momencie cofnąć na swoim profilu ze skutkiem dla
                                przyszłości.
                                <br>
                                Akcentuję Ogólne Warunki Handlowe. <a
                                    href="https://wroclaw.bmw-inchcape.pl/polityka-prywatnosci">Kliknij tutaj, aby
                                    przeczytać OWH.</a>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
        </div>
        <div class="flex-row flex-row--end">
            <router-link to="/car">
                <button class="btn btn--primary" :disabled="!validation.client || !isPhoneValid">Dalej do pojazdu</button>
            </router-link>
        </div>
    </div>
</template>

<script>
import lead from '@/mixins/lead.js'

export default {
    mixins: [lead],
    computed: {
        isPhoneValid() {
            if (!this.lead.phone_number) return false;
            const digitsOnly = String(this.lead.phone_number).replace(/\D/g, '');
            return digitsOnly.length >= 9;
        }
    }
}
</script>

<style lang="scss">
.c-client-form {
    &__container {
        max-width: 920px;
        margin: 0 auto;

        .flex-col {
            margin: 0;
        }
    }

    @media(min-width: 960px) {
        &__border {
            border-left: 1px solid $gray;
            border-right: 1px solid $gray;

            input[type=text],
            .input-placeholder {
                padding-left: 1rem;
                padding-right: 1rem;
            }

            input[type=text] {
                margin-top: 2rem;
            }

            &--left {
                border-left: 1px solid $gray;

                input[type=text],
                .input-placeholder {
                    padding-left: 1rem;
                }
            }

            &--noborder {
                border-left: none;
            }

            &--last {

                input[type=text],
                .input-placeholder {
                    padding-left: 1rem;
                }
            }
        }
    }
}
</style>